import React, { useRef } from "react";
import SwiperCore, { Navigation } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { NavLink } from "react-router-dom";
import "swiper/swiper-bundle.min.css";
import "styles/HotelsCarousel.css";
import hoteles from "assets/HotelesNacionales.json";
import { ReactComponent as BgLines } from "assets/patterns/Textura.svg";

// Instalar módulos de Swiper
SwiperCore.use([Navigation]);

const HotelsCarousel = () => {
  const swiperRef = useRef(null);

const hotelsList = hoteles.HotelesNacionales.filter((hotel) => hotel.noches === false);
  return (
    <section className="hotels-carousel">
      {/* Fondo dorado decorativo */}
      <div className="hotels-carousel__bg-gold">
        <BgLines className="hotels-carousel__bg-lines" />
      </div>

      <div className="hotels-carousel__container">
        {/* Header con título y navegación */}
        <div className="hotels-carousel__header">
          <div className="hotels-carousel__title-wrapper">
            <h2 className="hotels-carousel__title">Explora nuestros hoteles</h2>
            <NavLink to="/hoteles" className="hotels-carousel__link">
              ver todos <span className="hotels-carousel__link-arrow">→</span>
            </NavLink>
          </div>

          <div className="hotels-carousel__nav-wrapper">
            <button
              className="hotels-carousel__nav hotels-carousel__nav--prev"
              aria-label="Anterior"
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path
                  d="M15 19l-7-7 7-7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              className="hotels-carousel__nav hotels-carousel__nav--next"
              aria-label="Siguiente"
              onClick={() => swiperRef.current?.slideNext()}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path
                  d="M9 5l7 7-7 7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Carrusel */}
        <div className="hotels-carousel__slider">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            grabCursor={true}
            centeredSlides={true}
            initialSlide={2}
            loop={true}
            loopedSlides={5}
            slidesPerView={1}
            slidesPerGroup={1}
            spaceBetween={15}
            slideToClickedSlide={true}
            speed={400}
            breakpoints={{
              0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                spaceBetween: 15,
              },
              540: {
                slidesPerView: "auto",
                slidesPerGroup: 1,
                spaceBetween: 20,
              },
              900: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 25,
              },
              1024: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 30,
              },
              1400: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                spaceBetween: 35,
              },
            }}
            className="hotels-carousel__swiper"
          >
            {hotelsList.map((hotel) => (
              <SwiperSlide key={hotel.Hotel}>
                <NavLink
                  to={`/hoteles/${hotel.Destino}/${hotel.Hotel}`}
                  className="hotels-carousel__card"
                >
                  <div className="hotels-carousel__image-wrapper">
                    <img
                    src={hotel.miniatura}
                      alt={hotel.Hotel}
                      className="hotels-carousel__image"
                      loading="lazy"
                    />
                  </div>
                  <div className="hotels-carousel__card-footer">
                    <span className="hotels-carousel__card-name">
                      Hotel {hotel.Hotel}
                    </span>
                    <svg
                      className="hotels-carousel__card-arrow"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        d="M7 17L17 7M17 7H7M17 7V17"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </NavLink>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HotelsCarousel;
